import styled from 'styled-components';

const ConfigurationSection = styled.div`
    margin-bottom: 5rem;
`

export default ConfigurationSection;